import { ClientSubscription } from '../../types';
import { atomWithBroadcast } from './atomWithBroadcast';

export const clientSubscriptionsAtom = atomWithBroadcast<Array<ClientSubscription>>('core/clientSubscriptions', []);
